





































































import Vue from 'vue';
import { VMenu, VList, VDivider, VListItem, VListItemTitle } from 'vuetify/lib';
interface AiMenuItemsTypes {
  title: string;
  icon?: string;
  action?: () => void;
}

export default Vue.extend({
  name: 'AiMenuList',
  components: { VMenu, VList, VDivider, VListItem, VListItemTitle },
  data: () => ({
    showMenu: false
  }),
  props: {
    menuItems: {
      type: Array,
      default: () => []
    },
    isOffsetX: { type: Boolean, default: false },
    isOffsetY: { type: Boolean, default: true },
    isOpenOnHover: { type: Boolean, default: false },
    isSubMenu: { type: Boolean, default: false },
    transition: { type: String, default: 'scale-transition' },
    contentClass: {
      type: String,
      default: ''
    },
    left: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitClickEvent(item: AiMenuItemsTypes) {
      this.showMenu = false;
      this.$emit('click', item);
    }
  }
});
